import { EMPTY } from '@utils';
import { MatSnackBar } from '@angular/material';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { WorkbookService } from '@base/workbook/workbook.service';
import { AppService } from '@base/app.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TableauService } from '@base/tableau/tableau.service';
import { IWorkbooklog, IWorkbook, IUser } from '@interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { OpenWorkbookAs } from '@utils';

declare var tableau: any;
declare var workbook: any;

@Component({
  selector: 'app-tableau-workbook-view',
  templateUrl: './tableau-workbook-view.component.html',
  styleUrls: ['./tableau-workbook-view.component.sass']
})
export class TableauWorkbookViewComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  private fullScreenRequested: boolean;
  private previousState = false;
  private _workbook: IWorkbook = EMPTY;
  private _user: IUser = EMPTY;
  private isLoginAs: boolean;
  private _intervalId = null;

  url: string;
  showEmbed: boolean;
  showToolbar: boolean;
  screenHeight: number;
  screenWidth: number;
  showAsReport = true;
  snapshotUrl = null;

  viz: any;

  constructor(
    private workBookService: WorkbookService,
    private router: Router,
    private mainService: AppService,
    private snackBar: MatSnackBar,
    private tableauService: TableauService,
  ) {
    this.showEmbed = false;
    this.showToolbar = false;
    this.subscriptions = [];
    this.url = this.workBookService.getFinalUrl();
    this.tableauService.setNavBackButtonStatus(true);
    this.isLoginAs = mainService.isLoginAs;

    const obs1 = this.mainService.observefullScreen().subscribe(
      (status: boolean) => {this.fullScreenRequested = status; },
    );

    const obs2 = this.workBookService.observeWorkbookSelected().subscribe(
      (wb: IWorkbook) => this._workbook = wb,
    );

    const obs3 = this.mainService.getCurrentUser().subscribe(
      (u: IUser) => this._user = u,
    );

    const obs4 = this.workBookService.observeSnapshotUrl().subscribe(
      (url: string) => this.snapshotUrl = url
    );

    if (this.url.length === 0) {
      this.router.navigate(['/home/panels/tableau']);
    }

    this.subscriptions = [...this.subscriptions, obs1, obs2, obs3, obs4];
  }

  ngOnInit() {
    this.showEmbed = (this.url.length > 0);
    const payload: IWorkbooklog = {
      user: this._user,
      workbook: this._workbook,
    };

    if (this._workbook.open_as === OpenWorkbookAs.Report) {
      const placeholderDiv = document.getElementById('vizContainer');
      const options = {
        hideTabs: false,
        hideToolbar: true,
        width: '100%',
        height: `${window.innerHeight - 100}px`,
        onFirstInteractive: function () {
          // The viz is now ready and can be safely used.
          console.log('Carga de datos para el reporte ya finalizo. (Viz Tableau)');
        }
      };

      try {
        // Creating a viz object and embed it in the container div.
        var auxViz = new tableau.Viz(placeholderDiv, this.url, options);
        this.viz = auxViz;
        this.workBookService.setViz(this.viz);
        this.mainService.setStatusExportToolbar(true);

        // feature solo para Maxagro y Bastien...
        //if (this._workbook.company_id === 53 || this._workbook.company_id === 33) {
        //  this._intervalId = setInterval(function () {
        //    auxViz.refreshDataAsync();
        //  }, 60000);
        //}
      } catch (err) {
        console.log(err);
        this.openSnackBar('No se puede mostrar el reporte!', 'info');
      } finally {
        if (!this.isLoginAs) {
          this.workBookService.registerLog(payload).subscribe(
            (log: IWorkbooklog) => {},
            (err: HttpErrorResponse) => console.log(err.message)
          );
        }
      }
    }

    this.tableauService.setDisplayTagsStatus(false);
  }

  ngOnDestroy() {
    clearInterval(this._intervalId);
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
    this.mainService.setStatusExportToolbar(false);
  }

  private openSnackBar(message: string, action: string, duration = 4000): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: duration,
    }).afterDismissed().subscribe(
      () => {this.router.navigate(['/home/panels/tableau']); }
    );
  }

  onResize(event) {
    let auxHeight = `${window.innerHeight - 100}px`;

    if (this.fullScreenRequested && this.previousState) {
      this.fullScreenRequested = false;
      auxHeight = `${window.innerHeight - 100}px`;
    } else if (!this.fullScreenRequested && !this.previousState) {
      auxHeight = `${window.innerHeight - 100}px`;
    } else {
      auxHeight = '99vh';
    }

    this.previousState = this.fullScreenRequested;
    this.viz.setFrameSize(window.innerWidth, auxHeight);
  }
}
